<template>
    <div class="staff">
        <List :DB="list" @emit="emit" />
        <component v-if="component" :is="component" :item="item" @emit="emit" />
    </div>
</template>

<script>

import { mapMutations } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import prettyPhone from '../utils/prettyPhone.js'
import makeMSISDN from '../utils/makeMSISDN.js';
import WebSoc from '../utils/WebSoc.js'
import editStaff from '../components/editStaff.vue';
import statsStaff from '..//components/statsStaff.vue';
import Alert from '../utils/Alert.js';

export default {
    name: 'staff-items',
    components: {
        List,
        editStaff,
        statsStaff,
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    mounted () {
        this.list.filter.client_id = this.client_id;
    },
    data () {
        return {
            component: '',
            item: false,            
            list: { 
                t: 'staff-list',
                DB: 'users',
                storeDB: true,
                title: 'Staff',
                fields: [
                    { title: 'Status', field: 'suspend', width: 200, map: item => item.suspend === true ? 'SUSPENDED ' : 'ACTIVE' },
                    { title: 'Joined', field: 'created', class: 'ta-r', width: 170, order: 'asc', type: 'date', map: item => item.created > 0 ? format(item.created,'dd/MM/yy HH:mm') : '' },
                    { title: 'Name', field: 'name', class: 'td-ulb', width: '1fr'  },
                    { title: 'Staff #', field: 'staffNo', width: 110, type: 'num' },
                    { title: 'User Name', field: 'username', width: 140 },
                    { title: 'Mobile', field: 'prettyPhone', width: '1fr' },
                    { title: 'Email', field: 'email', width: '1fr' },
                    { title: 'Verified', field: 'Verified', width: 140, type: 'date', map: item => item.Verified > 0 ? format(item.Verified,'dd/MM/yy HH:mm') : 'Not Verified' },
                    { title: 'Stamps', field: 'loyaltyQty', width: 100, class: 'ta-r td-ulb', type: 'num', map: item => item.loyaltyQty > 0 ? item.loyaltyQty : '' },
                    { title: 'Redeems', field: 'redeemReward', width: 100, class: 'ta-r td-ulb', type: 'num', map: item => item.redeemReward > 0 ? item.redeemReward : '' },
                    { title: 'Last Activity', field: 'active', width: 160, class: 'ta-r', type: 'date', map: item => item.active > 0 ? format(item.active,'dd/MM/yy HH:mm') : '' }
                ],
                filter: {},
                project: { client_id: 1 }
            } 
        }
    },
    methods: {
        newStaff () {
            var staff = {
                suspend: false,
                dashboard: false,
                manager: false,
                notes: '',
                name: '',
                phone: '',
                email: '',
                username: '',
            }
            this.setComponent(staff,'editStaff');
        },
        'stats-staff' ({ action, field, item, value, e }) {
            switch ( action ) {
                case 'exit':
                    this.setComponent(false);
            }
        },
        'staff-list' ({ action, field, item, value, e }) {
            if ( action == 'new' ) return this.newStaff();
            switch ( field.field ) {
                case 'name':
                    WebSoc.SEND('get',{ DB: 'users', _id: item._id },staff => {
                        this.setComponent(staff,'editStaff');       
                    });
                break;
                case 'loyaltyQty':
                case 'redeemReward':
                    WebSoc.SEND('get',{ DB: 'users', _id: item._id },staff => {
                        this.setComponent(staff,'statsStaff');
                    })    
                default:
                    console.log('staff-list ?',field.field);    
            }
        },
        'edit-staff' ({ action, item, update }) {
            switch ( action ) {
                case 'exit':
                    this.setComponent(false);
                    break;
                case 'save':

                    if ( update.mobile ) {
                        update.prettyPhone = prettyPhone(update.mobile);
                        update.msisdn = makeMSISDN(update.mobile);
                    }
                    
                    if ( item._id ) {
                        this.setComponent(false);
                        if ( Object.keys(update).length == 0 ) return;
                        WebSoc.SEND('update',{ DB: this.list.DB, _id: item._id, update: { $set: update }},() => console.log('updated'));
                    } else {
                        this.setComponent(false);
                        item.client_id = this.client_id;
                        WebSoc.SEND({ t: 'saveClientStaff', data: { DB: 'users', new: item }},resp => {
                            console.log('saveClientStaff resp',resp);
                            if ( resp.errorMessage ) { this.setComponent(item,'editStaff'); return Alert.message(resp.errorMessage); }
                            if ( resp.success ) return Alert.message('Added '+user.name);
                        })
                    }
                    break;
                case 'delete':
                    if ( !item._id ) {
                        this.setComponent(false);
                    } else {
                        Alert.yesno('Delete '+item.name+' ?',yes => {
                            if ( !yes ) return;
                            this.setComponent(false);
                            WebSoc.SEND("delete",{ DB: 'users', _id: item._id },() => console.log('deleted',item.name));
                        })
                    }
                    break;
                    default:
                        console.log('what with ?',action);

            }
        },
        setComponent ( item, component ) {
            this.item = item;
            if ( item == false ) {
                this.component = ''
            } else {
                this.component = component
            }
        },
        emit ( data ) {
            //console.log('data',data);
            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
            console.log('what emmit',data.t);
        },
    }
}   

</script>